import React, { useState } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { HNISERVICESURL, SERVICES } from "../../Configuration/Telecaller_URl";
import * as CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AESEncryption, ApiResDecrypt, allTrim, errData, onlyNumber } from "../../CommonMethhods/CommonMethods";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Loader from "../../Components/Common/Loader";
import { useEffect } from "react";

function HniDeleteDashboard() {
  const navigate = useNavigate();
  const [session, setSession] = useState(false);
  const [errorData, setErrorData] = useState("");
  const [application, setApplication] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [clintDtails, setClintDetails] = useState("");
  const [deletUnauthorize, setDeletUnauthorize] = useState(false);
  const [existNumber, setExistNumber] = useState(false);
  const [loader, setLoader] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false)
  const [showObjectionField, setShowObjectionField] = useState(false);
  const [reasonList, setReasonList] = useState([])

  const [validationSchema, setValidationSchema] = useState(
    Yup.object().shape({
      objectionType: Yup.string().required("Select rejection type"),
    })
  );

  const numberchema = Yup.object().shape({
    numberAndRef: Yup.string()
      .required("Please enter mobile number or RefNo")
      .matches(
        /^[A-Za-z0-9]{10,20}$/,
        "Number or RefNo will be 10 to 20 digits"
      ),
  });


  const {
    register: regestereson,
    handleSubmit,
    formState: { errors: resonError },
    resetField,
    setValue,
    watch,
    trigger
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const {
    register: regesterNumberInput,
    handleSubmit: handleSubmitNumber,
    formState: { errors: numberError },
    setValue: setNumberVal,
    getValues: getNumberValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(numberchema),
  });
  function submitApplication() {
    setApplication(false);
  }
  const resonSubmit = (value) => {
    console.log(value, "value");
    let rejectionObj = { reason: value }
    // console.log(rejectionObj, "rejectionObj");
    confirmDelete(clintDtails, rejectionObj)
  }
  function showDetails(data) {
    setLoader(true);
    clientsDetails(data);
  }
  const selectedValue = watch("objectionType");
  useEffect(() => {
    // document.getElementById("delete-error-text").style.display = "none";
   
    const schema = selectedValue === "Others"
      ? Yup.object().shape({
        objectionType: Yup.string().required("Select reason type"),
        objection: Yup.string()
          .required("Please Add Reason")
          .min(10, "Minimum length should be 10 characters")
          .max(150, "Max length should be 150 characters"),
      })
      : Yup.object().shape({
        objectionType: Yup.string().required("Select Reason type"),
      });
      setErrorSet(false)
    setValidationSchema(schema);
    setShowObjectionField(selectedValue === "Others");
    if (selectedValue !== "Others") {
      setValue("objection", "");
      // document.getElementById("delete-error-text").style.display = "none";
    }
  }, [selectedValue]);

  const clientsDetails = async (data) => {
    let detailsUpdate = {
      mobile: data.numberAndRef,
      userId: localStorage.getItem("userId"),
    };
    let encPayload = AESEncryption(detailsUpdate);
    try {
      const response = await axios.post(
        `${HNISERVICESURL.GetClientDetails}`,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            reserv: 1,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      
      let responseUpdated = ApiResDecrypt(data);
      console.log(responseUpdated, "responseUpdated");
      if (responseUpdated.status === 0) {
        
        if(responseUpdated?.data?.leadDetails === null){
          setClintDetails(responseUpdated?.data?.details);
        }
        else if(responseUpdated?.data?.details === null){
        setClintDetails(responseUpdated?.data?.leadDetails);
        setShowTable(true);
        }
        
        if (responseUpdated?.data?.details?.message === "Account already submitted") {
          setApplication(true);
          setShowTable(false);
          return;
        }
        if (
          responseUpdated.data?.details?.message ==
          "Another Telecaller user is working on this application"
        ) {
          setExistNumber(true);
          setShowTable(false);
          return;
        } else {
          setExistNumber(false);
        }
      } else {
        setErrorData(responseUpdated.message);
        setShowTable(false);
      }
      return;
    } catch (err) {
      setShowTable(false);
      if (err) {
        if (err.request.status == "401") {
          setSession(true);
        } else {
          setSession(false);
        }
      } else {
        const data = await err.response.data;
        let responseError = ApiResDecrypt(data);
        console.log(responseError, "responseError");
        setDeletUnauthorize(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const sessionExpired = () => {
    setSession(false);
    localStorage.clear("");
    navigate("/");
  };
  function closeExistNumber() {
    setExistNumber(false);
  }
  const confirmDelete = async (clintDtails, rejectionObj) => {
    // debugger
    // console.log(clintDtails, rejectionObj, "alldetais");
    let updateConfirm = {
      id: clintDtails.id,
      mobile: clintDtails.mobile,
      userId: localStorage.getItem("userId"),
      reason: rejectionObj.reason
    }
    // console.log(updateConfirm, "updateConfirm");

    let encPayload = AESEncryption(updateConfirm);
    // return
    try {
      const response = await axios.post(
        `${HNISERVICESURL.getDeleteApplication}`,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            reserv: 1,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      let comfResponse = ApiResDecrypt(data);
      // debugger
      console.log(comfResponse, "comfResponse");
      if (comfResponse.status == 0) {
        if (comfResponse.data == "EKYC Application deleted Successfully") {
          // debugger
          setErrorData(comfResponse.data);
          setShowTable(false);
          // clientsDetails(comfResponse.data);
          // setDeleteModal(false);
          setValue("objectionType", "")
          setValue("objection", "")

        } else {
          return;
        }
      } else {
        toast.error(comfResponse.message);
      }

    } catch (err) {
      if (err.request.status == "401") {
        setSession(true);
      } else {
        setSession(false);
      }
    } finally {
      setDeleteModal(false)
    }

  };

  function deleteApplication() {
    setDeleteModal(true)
  }
  const[errorSet,setErrorSet]=useState(false)
  useEffect(() => {
    // const errorTextElement = document.getElementById("delete-error-text");
    // if (errorTextElement) {
    //   errorTextElement.style.display = "none";
    // }
    getReasons();
  }, []);
  const validateInput = (e) => {
    let value = e.target.value;
    value = value.replace(/<[^>]*>?/gm, '');
    value = value.replace(/^\s+/g, '');
    value = value.replace(/\s\s+/g, ' ');
    e.target.value = value;
    // console.log(e.target.value = value, value.length);
    if (value.length == 150) {
      setErrorSet(true)
      // document.getElementById("delete-error-text").style.display = "block";
    }else{
      setErrorSet(false)
      // document.getElementById("delete-error-text").style.display = "none";
    }
    // setValue("objection", value, { shouldValidate: true });
    // trigger("objection");
  };
  const getReasons = async () => {
    try {
      const response = await axios.get(`${HNISERVICESURL.getDeleteReasons}`,
        {
          headers: {
            "content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = response.data;
      console.log(data);
      console.log(data.status, "comfResponse");
      if (data.status === 0 && data.data && Array.isArray(data.data.deletedReasonList)) {
        setReasonList(data.data.deletedReasonList);
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      if (err.request.status === 401) {
        setSession(true);
      } else {
        setSession(false);
      }
    } finally {
      setDeleteModal(false);
    }
  };
  console.log(reasonList, "reasonList");
  function close() {
    setDeleteModal(false)
    setDeletUnauthorize(false);
  }

  const closeModal = () => {
    setDeleteModal(false)
    setErrorSet(false)
    setValue("objectionType", "")
    setValue("objection", "")
    // document.getElementById("delete-error-text").style.display = "none";


  }

  return (
    <>
      <div className="telecaller telecallerDash">
        <div className="card-box">
          <div className="row telecaller-form">
            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">
                  Mobile Number<span className="star_text">*</span>
                </label>
                <input
                  type="text"
                  id="FromDate"
                  placeholder="Enter Mobile Number"
                  onInput={(e) => {
                    allTrim(e);
                    setErrorData("");
                    setShowTable(false);
                  }}
                  onKeyPress={(e) => {
                    if (!/^[A-Za-z0-9]$/.test(e.key)) {
                        e.preventDefault();  // Reject the key press
                    }
                }}
                  {...regesterNumberInput("numberAndRef")}
                  className={`form-control ${numberError?.numberAndRef ? "is-invalid" : ""
                    }`}
                  autoComplete="off"
                  maxLength={20}
                />
                <div className="invalid-feedback number-field hni-del-dashboard">
                  {numberError.numberAndRef?.message}
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 col-6">
              <button
                type="submit"
                className="send-message"
                onClick={handleSubmitNumber(showDetails)}
              >
                GET DETAILS
              </button>
            </div>
          </div>

          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <>
              <div className="table-responsive scroll-table telecaller-table-wrapper delete-table">
                {showTable ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Customer Name</th>
                        <th>PAN</th>
                        <th>Mobile</th>
                        <th>Registed date</th>
                        <th>Application Status</th>
                        <th>KYC</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{clintDtails?.id}</td>
                        <td>{clintDtails?.name}</td>
                        <td>{clintDtails?.pan}</td>
                        <td>{clintDtails?.mobile}</td>
                        <td>{clintDtails?.cDate}</td>
                        <td>{clintDtails?.applicationStatus}</td>
                        <td>{clintDtails?.isKyc}</td>
                        <td>
                          <div className="tele-btn-wrapper">
                            <button
                              type=""
                              className="tele-btn"
                              onClick={deleteApplication}
                            >
                              Delete Application
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <>
                    <p class="no-data-found">{errorData}</p>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>


      <Modal
        show={deletUnauthorize}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="signoutModal"
        className="rm-model"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          <button
            type="button"
            onClick={close}
            className="btn-close filter-closeBtn"
            aria-label="Close"
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">Request not authorized response</h4>
          <div className="btn-yes-no">
            <Button className="yes-btn confirmation-btn" onClick={close}>
              OK
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={application}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rm-model"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          <button
            type="button"
            onClick={submitApplication}
            className="btn-close filter-closeBtn"
            aria-label="Close"
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">Application already submitted</h4>
        </Modal.Body>
      </Modal>
      
      <Modal
        show={session}
        onHide={() => setSession(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        className="popup rm-model session-expired"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* Change Gender */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">
            Session has been expired,Please Login again...
          </h4>
          <div className="btn-yes-no">
            <Button
              className="yes-btn confirmation-btn"
              onClick={() => sessionExpired()}
            >
              OK
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={existNumber}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rm-model"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* Change Gender */}
          </Modal.Title>
          <button
            type="button"
            onClick={closeExistNumber}
            className="btn-close filter-closeBtn"
            aria-label="Close"
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">
            Another Telecaller user is working on this application
          </h4>
          <div className="btn-yes-no">
            <Button
              className="yes-btn confirmation-btn"
              onClick={closeExistNumber}
            >
              OK
            </Button>
            {/* <Button
              className="no-btn confirmation-btn"
              closeButton
              onClick={closeGenderModel}
            >
              No
            </Button> */}
          </div>
        </Modal.Body>
        {/* <Modal.Footer> */}

        {/* </Modal.Footer> */}
      </Modal>
      <Modal
        show={deleteModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model oms-rejection-modal"
        backdrop="static"
        keyboard={false}
      >
        <form onSubmit={handleSubmit(resonSubmit)}>
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">Are you sure want to Delete Application?</h2>
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => closeModal()}>
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-oms form-group">
              <label htmlFor="name" className="form-label">
                Reason Type :<span style={{ color: "red" }}>*</span>
              </label>
              {/* <input type="text" className="form-control"></input> */}
              <div className="delete-modal">
                <select
                  className="form-control"
                  id="user_type"
                  name="userType"
                  type="text"
                  {...regestereson('objectionType')}
                // onChange={(e) => {
                //   UserTypeChange(e);
                // }}
                // onChange={(e) => checkOptions(e, setValidationSchema)}
                // onChange={(e) => checkOptions(e)}
                >
                  <option value="">Select Reason Type</option>
                  {reasonList.length > 0 && reasonList.map((reason, i) => (
                    <option key={i} value={reason.Reason}>
                      {reason.Reason}
                    </option>
                  ))}
                </select>
                <div className="modal-error number-field">
                  {resonError.objectionType?.message}
                </div>
              </div>
            </div>

            {showObjectionField && (
              <div className="modal-oms form-group" id="Objection">
                <label className="form-label">Add Reason :<span style={{ color: "red" }}>*</span></label>
                <div className="delete-modal">
                  <textarea
                    rows={5}
                    className="form-control"
                    maxLength={150}
                    {...regestereson("objection")}
                    onInput={(e) => validateInput(e)}
                  ></textarea>
                  <div className="number-field modal-error">
                    {resonError.objection?.message}
                  </div>
                  {errorSet&&
                  <>
                    <div className="number-field modal-error" id="delete-error-text" >
                    Max length should be 150 characters
                  </div>
                  </>
                  }
                 
                </div>
              </div>
            )}
          </Modal.Body>
          <div className="button-oms-modal">
            <button className="oms-close" onClick={() => closeModal()}>
              NO
            </button>
            <button className="send-message"
            //  onClick={AddNewObjection}
            >
              YES
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
export default HniDeleteDashboard;